export const loadLocal = <T>(key: string, allowedValues: T[]): T | undefined => {
  try {
    const value = localStorage.getItem(key) as T | null
    if (value === null) {
      return undefined
    }

    return allowedValues.includes(value) ? value : undefined
  } catch (e) {
    console.log('loadLocal error')
    return undefined
  }
}

export const saveLocal = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value)
  } catch (e) {
    console.log('saveLocal error')
  }
}
